<!-- eslint-disable vue/no-mutating-props -->
<template>
    <Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
         <div class="field">
            <label>City Name</label>
            <InputText v-model="item.city_name" required="true" autofocus :class="{ 'p-invalid': errorEdit.city_name }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.city_name" >{{ errorEdit.city_name[0] }}</small >
        </div>
        <div class="field">
            <label>Territory</label>
            <Dropdown dataKey="code" 
                    ref="dteritory" v-model="item.territory_id" 
                    :loading="loadingDropdownTerritory" 
                    :options="dataDropdownTerritory" 
                    :class="{ 'p-invalid': errorEdit.territory_id }" 
                    optionLabel="label" optionValue="territory_id" 
                    placeholder="Select Territory" :filter="true" 
                    :showClear="true" @filter="searchDropdownTerritory($event,'edit')"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.territory_id" >{{ errorEdit.territory_id[0] }}</small>
        </div>
         <div class="field">
            <label>City Status</label>
            <Dropdown v-model="item.city_status" :options="dataDropdownStatus" optionLabel="name" optionValue="code" placeholder="Select Status" :class="{ 'p-invalid': errorEdit.city_status }"/>
                <small class="p-invalid" style="color: red" v-if="errorEdit.city_status" >{{ errorEdit.city_status[0] }}</small>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Update" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loading"/>
        </template>
    </Dialog>
</template>


<script>

import { mapGetters } from "vuex";

export default {
    props: [
		"item",
    ],
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownTerritory: false,

            // dataDropdown
            dataDropdownTerritory: null,
            dataDropdownStatus: [
                {name: 'ACTIVE', code: 'y'},
                {name: 'NON ACTIVE', code: 'n'},
            ],

            // edit
            editItemDialog: false,
        }
    },
    mounted() {
        this.$store.commit('setErrorEdit', {});
    },
    watch: {
        editItemDialog: {
            handler() {
                setTimeout(() => {
                    if(this.editItemDialog == true){
                        this.searchDropdownTerritory('', 'edit', this.item.territory_name);
                    }
                    this.$store.commit('setErrorEdit', {});
                }, 500);
            },
        }
    },
    computed:{
        ...mapGetters(['errorEdit']),
		...mapGetters("auth", ["user"]),
    },
    methods: {
        // DROPDOWN
        searchDropdownTerritory(event, purpose, valueEdit){
            setTimeout(() => {
                if(valueEdit){
                    this.$refs.dteritory.filterValue = valueEdit;
                }

                if(purpose == "edit"){
                    this.loadingDropdownTerritory = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-territory3',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "edit"){
                        this.dataDropdownTerritory = res.data.data;
                        this.loadingDropdownTerritory = false;
                    }else if(purpose == null){
                        this.dataDropdownTerritory = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // EDIT
		hideDialog() {
			this.editItemDialog = false;
		},
		updateItem() {
            this.loading = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/city/update',
                data: {
                    "city_id": this.item.city_id,
                    "city_name": this.item.city_name,
                    "territory_id": this.item.territory_id,
                    "city_status" : this.item.city_status,
                },
            })
            .then((res) => {
                this.loading = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    // this.item = {};
                    this.editItemDialog = false;
                    this.$emit('submit');
                }
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                this.$store.commit('setErrorEdit', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000,});
            });
		},
    }
}
</script>